<template>

    <!-- Hamburger Menu -->
    <div
        class="select-none print:hidden
        w-full sm:max-w-sm transition-all transform-gpu duration-500 transform-gpu bg-white border-l-4 border-gray-200 shadow-lg h-screen fixed right-0 z-[60]
        dark:bg-gray-800 dark:border-gray-600 dark:text-ncfic-blue-100"
        :class="showMenu ? '' : 'translate-x-full'"
        @click.stop
    >

        <button class="absolute top-0 right-0 cursor-pointer m-4" @click="showMenu = false">
            <i class="fal fa-lg fa-times" />
        </button>

        <div class="flex flex-col text-xl space-y-6 p-8 border-b dark:border-gray-600" @click="showMenu = false">
            <!-- <router-link class="border-b border-transparent hover:underline" to="/account">
                Account
            </router-link> -->
            <router-link
                v-for="link in links"
                class="border-b border-transparent hover:underline"
                :key="link.name"
                :to="link.path"
            >
                {{ link.name }}
            </router-link>
        </div>
        <div @click.stop class="p-8 border-b dark:border-gray-600 text-sm">
            <div class="space-y-4">
				<div class="text-sm">
					<a href="https://cf.life" class="hover:underline">
						Church &amp; Family Life<i class="fal fa-sm fa-long-arrow-right inline" />
					</a>
				</div>
				<div class="text-sm">
					<a href="https://cf.life/network/" class="hover:underline">
						FIC Network&nbsp;&nbsp;&nbsp;<i class="fal fa-sm fa-long-arrow-right inline" />
					</a>
				</div>
				<div class="text-sm">
					<a :href="`https://cf.life/sermons?filters={%22speakers%22:[{%22title%22:%22Scott+Brown%22,%22image%22:{%22width%22:100,%22height%22:100,%22url%22:%22https://cfl-mango.s3.amazonaws.com/assets/people/60ca3431e7346d3c2b733f3d/image.jpg%22},%22id%22:%2260ca3431e7346d3c2b733f3d%22,%22objectID%22:%2260ca3431e7346d3c2b733f3d%22,%22_highlightResult%22:{%22title%22:{%22value%22:%22%3Cem%3ESc%3C/em%3Eott+Brown%22,%22matchLevel%22:%22full%22,%22fullyHighlighted%22:false,%22matchedWords%22:[%22sc%22]}}}],%22church%22:[],%22series%22:[],%22book%22:[],%22duration%22:[0,4500]}`" class="hover:underline">
						Expository Preaching&nbsp;&nbsp;&nbsp;<i class="fal fa-sm fa-long-arrow-right inline" />
					</a>
				</div>
            </div>
        </div>
        <div @click.stop class="p-8 text-sm">
            <div>
                Scott Brown Online is the personal blog of Scott Brown, pastor of Hope Baptist Church and President of Church &amp; Family Life.
            </div>
        </div>
    </div>

    <!-- Top Nav Bar -->
    <div class="sticky top-0 z-50" v-show="!hidden">
        <div
            @scroll="handleScroll"
            class="
                space-x-8 backdrop-blur
                text-ncfic-blue-500 border-b border-ncfic-blue-100 bg-white/90 flex justify-between items-center px-4 w-full h-14
                dark:text-ncfic-blue-100 dark:border-gray-600 dark:bg-gray-800/50 print:hidden
            "
        >
            <router-link class="w-48" to="/">
                <img alt="Logo" src="https://churchandfamilylife.com/uploads/about/sbo-dark-min.png" class="dark:hidden fill-ncfic-blue-700 dark:fill-ncfic-blue-50 w-48" />
                <img alt="Logo" src="https://churchandfamilylife.com/uploads/about/SBO_Logo.png" class="hidden dark:block fill-ncfic-blue-700 dark:fill-ncfic-blue-50 w-48" />
            </router-link>
            <div class="flex justify-between space-x-10 hidden lg:block truncate">
                <template v-for="link in links" :key="link.name">
                    <router-link
                        class="hover:text-blue-400 py-1"
                        :to="link.path"
                    >
                        {{ link.name }}
                    </router-link>
                </template>
            </div>
            <router-link class="hidden sm:block lg:hidden" to="/">Scott Brown Online</router-link>
            <div class="w-48 flex justify-end items-center space-x-4">
                <a v-if="store.user?.member?.roles?.includes('admin')" href="https://admin.churchandfamilylife.com/blogs/create" class="text-lg block"><i class="fad fa-file-alt" /></a>
                <button v-if="store.user?.member?.roles?.includes('admin') && $route.params?.id" @click="openAdminPage" class="text-lg"><i class="fad fa-pencil-alt" /></button>
                <button @click="darkMode.toggle" class="text-xl"><i class="fad" :class="!darkMode.enabled ? 'fa-sun' : 'fa-moon-stars mb-2'" /></button>
                <button class="lg:hidden" @click.stop="showMenu = !showMenu"><i class="fal fa-bars text-ncfic-blue-700 dark:text-ncfic-blue-50 text-lg" /></button>
            </div>
        </div>
        <!-- Toast -->
        <!-- <router-link to="/donate" class="flex items-center justify-center text-sm md:text-base w-full bg-gradient-to-tr md:bg-gradient-to-r from-ncfic-blue-300 to-ncfic-green-300 via-gray-100 dark:from-ncfic-blue-800 dark:to-ncfic-green-800 dark:via-gray-800 px-4 py-2 text-center font-semibold uppercase border-b-2 dark:border-gray-700">
            Donate now and double the impact with a matching gift of $100k!
        </router-link> -->
    </div>

    <Modal v-if="showSearch" @hide="showSearch = false" max-width="max-w-2xl">
        <div class="text-sm sm:text-base md:text-lg flex justify-between w-full items-start">
            <div>Search for Anything!</div>
            <button @click="showSearch = false">
                <i class="fal fa-times ml-4" />
            </button>
        </div>
        <input
            type="text"
            v-model="search.value"
            class="w-full text-sm sm:text-base md:text-lg"
            placeholder="Search"
            ref="search"
            @keyup.down="search.activeIndex++"
            @keyup.up="search.activeIndex--"
            @keydown.enter="$router.push(`/${search.results?.[search.activeIndex]?.collection}/${search.results?.[search.activeIndex]?.id}`); showSearch = false"
        />
        <!-- Something is breaking and keeping the slot content from showing up! -->
        <Mango
            :algoliaSearch="search.value"
            :algoliaFilters="`collection:blogs`"
            :globalSearch="true"
            :query="{limit: 50}"
            @update:data="test"
            @update:loading="search.loading = $event"
        />
        <div v-if="search.loading && search.value" class="flex items-center justify-center"><Spinner :small="true" class="w-8 h-8 mt-2" /></div>
        <div v-else-if="search.value" class="space-y-2 sm:space-y-4">
            <a
                href="https://read.jttb.co"
                target="_blank"
                v-if="['read','journey','jttb','yearly','plan','reading'].some(t => search.value?.toLowerCase()?.includes(t))"
                @click="showSearch = false"
                class="p-2 sm:p-4 dark:bg-gray-700 rounded shadow-card flex flex-col group transition-all"
            >
                <div class="flex items-center space-x-4">
                    <div class="truncate">
                        <div class="text-xs uppercase font-semibold mb-1 text-ncfic-blue-500">Bible Reading Plan</div>
                        <div class="group-hover:underline truncate">Journey Through the Bible</div>
                    </div>
                </div>
                <div class="text-xs line-clamp-2 mt-4">
                    Daily reading plan with study tools to help you read the entire Bible in one year.
                </div>
            </a>
            <router-link
                :to="entry.collection == 'people' ? `/resources/authors/${entry.id}` : `/${entry.collection}/${entry.id}`"
                v-for="entry, index in search.results.filter(r => r.collection != 'events' || r.startDate > new Date())"
                :key="entry.id"
                @mouseover="search.activeIndex = index"
                @mouseout="search.activeIndex = null"
                @click="showSearch = false"
                class="p-2 sm:p-4 dark:bg-gray-700 rounded shadow-card flex flex-col group transition-all"
                :class="{'scale-105 dark:bg-gray-600 bg-sky-50': search.activeIndex == index}"
            >
                <div class="flex items-center space-x-4">
                    <div class="hidden sm:flex rounded w-20 h-20 shrink-0 border border-white dark:border-gray-400 bg-gray-800 uppercase text-white/60 text-sm relative overflow-hidden items-center justify-center">
                        <div v-if="entry.title">{{ entry?.title?.[0] }}</div>
                        <div v-else><i class="fa fa-question" /></div>
                        <div class="bg-cover bg-center w-full h-full absolute inset-0" :style="`background-image: url('${entry?.image?.url || entry?.bannerImage?.url || entry?.video?.thumbnail}')`" />
                    </div>
                    <div class="truncate">
                        <div
                            class="text-2xs uppercase font-semibold mb-1 tracking-widest"
                            :class="collectionColors[entry.collection] || 'text-ncfic-blue-500'"
                        >
                            {{ entry.collection }}
                        </div>
                        <div class="group-hover:underline truncate" :class="{'underline': search.activeIndex == index}">{{ entry.title }}</div>
                        <div v-if="entry.authors?.length > 1 || entry.speakers?.length > 1" class="truncate mt-2">
                            <People :people="entry.authors || entry.speakers" size="w-8 h-8" space="-space-x-2" :limit="8" :tooltip="true" />
                        </div>
                        <div v-else class="truncate">
                            <div class="text-xs opacity-70">
                                {{ entry.authors.map(a => a.title).join(', ') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-xs line-clamp-3 mt-4" v-if="entry.descriptionMin || entry.bodyMin || entry.bioMin || entry.bio || entry.summary || entry.aiSummary || entry.transcription" v-html="entry.descriptionMin || entry.bodyMin || entry.bioMin || entry.bio" />
            </router-link>
        </div>
    </Modal>
</template>

<script>
import logo from '../../assets/logo.vue'
import Login from '../layout/login.vue'
import Subscribe from '../layout/subscribe.vue';
import {Menu, MenuButton, MenuItems, MenuItem} from '@headlessui/vue';
import People from '../layout/people.vue';

export default {
    components: { logo, Login, Subscribe, Menu, MenuButton, MenuItems, MenuItem, People },
    props: {hidden: {type: Boolean, default: false}},
    inject: ['store', 'darkMode'],
    data() {
        return {
            showLogin: false,
            showSearch: false,
            keyListener: null,
            search: {
                activeIndex: 0,
                value: null,
                results: [],
                loading: false
            },
            email: null,
            showMenu: false,
            links: [
                { name: `Blogs`, path: `/blogs` },
                { name: `About`, path: `/about` },
                { name: `Invite`, path: `/invite` },
                { name: `Store`, path: `/products` },
            ],
            collectionColors: {
                podcasts: 'text-ncfic-green-500',
                events: 'text-red-500',
                products: 'text-red-500',
                people: 'text-orange-500',
            }
        }
    },
    mounted() {
        this.keyListener = function(e) {
            if (e.key === "k" && (e.ctrlKey || e.metaKey)) {
                e.preventDefault(); // present "Save Page" from getting triggered.
                this.showSearch = !this.showSearch
            }
        };
        document.addEventListener('keydown', this.keyListener.bind(this));
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.keyListener);
    },
    watch: {
        showSearch() {
            if (this.showSearch) {
                this.$nextTick(() => {
                    this.$refs.search.focus()
                    this.$refs.search.select()
                })
            }
        }
    },
    methods: {
        test(data) {
            this.search.results = data
        },
        openAdminPage() {
            let collection = this.$route.path.split('/')[1]
            collection = ['network', 'church-network'].includes(collection) ? 'churches' : collection
            collection = ['podcasts'].includes(collection) ? 'podcastEpisodes' : collection
            collection = ['about'].includes(collection) ? 'aboutPages' : collection
            console.log('collection')
            let id = this.$route.params?.id

            let path = `https://admin.churchandfamilylife.com/${collection}/${id}`
            // window.open(path, "_blank") || window.location.replace(path);
            window.location.replace(path);
        }
    },
    computed: {
        loggedIn() {
            return this.store.user?.member?.id
        }
    }
}
</script>

<style lang="postcss" scoped>
input, label {
    @apply border border-gray-300 rounded outline-blue-400 dark:outline-blue-500/40 focus-visible:dark:outline-blue-500/40 px-3 py-2 dark:bg-transparent dark:border-gray-600 dark:placeholder-gray-600
}
input.dark-sidebar {
    @apply dark:border-white/70 dark:placeholder:text-white/30 dark:text-white
}
</style>
